import PropTypes from 'prop-types'
import React from 'react'

import {
  NEWSLETTER_CONSENT_LABEL,
  PRIVACY_POLICY_URL
} from '../../../utils/accountConsent'
import './styles.css'

// SPEC-099: an optional, unticked newsletter opt-in. It never blocks
// submitting the form it sits in. SPEC-101 D8: a form whose terms line
// already links the Privacy Policy passes privacyLink={false}.
function NewsletterConsent({
  id,
  inputProps = {},
  dark = false,
  privacyLink = true
}) {
  return (
    <div className={`NewsletterConsent${dark ? ' -dark' : ''}`}>
      <input {...inputProps} type="checkbox" id={id} />
      <div className="NewsletterConsent__copy">
        <label htmlFor={id}>{NEWSLETTER_CONSENT_LABEL}</label>
        {privacyLink && (
          <>
            {' '}
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </>
        )}
      </div>
    </div>
  )
}

NewsletterConsent.propTypes = {
  id: PropTypes.string.isRequired,
  // react-hook-form's register(...) result
  inputProps: PropTypes.object,
  dark: PropTypes.bool,
  privacyLink: PropTypes.bool
}

export default NewsletterConsent
